/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_ConfigureInputs */

const cs_portals_configure = /** @type {(inputs: Portals_ConfigureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit`)
};

const en_portals_configure = /** @type {(inputs: Portals_ConfigureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure`)
};

/**
* | output |
* | --- |
* | "Configure" |
*
* @param {Portals_ConfigureInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_configure = /** @type {((inputs?: Portals_ConfigureInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_ConfigureInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_configure(inputs)
	return cs_portals_configure(inputs)
});